const fetchStudentData = async (backendUrl, subscriberCode) => {
  try {
    let data = await fetch(
      `${backendUrl}/student/alldata?subcode=${subscriberCode}`
    );
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching student data:", error);
  }
};

const fetchUsersData = async (backendUrl, organization, subCode, username, role) => {
  try {
    let data;
    data = await fetch(
      `${backendUrl}/user/data?orgcode=${organization}&subcode=${subCode}&username=${username}&role=${role}`
    );
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching student data:", error);
  }
};

const fetchInstructorsData = async (backendUrl, subscriberCode) => {
  try {
    let data = await fetch(
      `${backendUrl}/instructor/data?subcode=${subscriberCode}`
    );
    data = await data.json();
    console.log(data);
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching student data:", error);
  }
};

const updateUserProfile = async (backendUrl, formData) => {
  try {
    let data = await fetch(`${backendUrl}/student/profile-update`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error updating student data:", error);
  }
};

const fetchSchoolsData = async (backendUrl, organization) => {
  try {
    let data = await fetch(
      `${backendUrl}/school/public-profile?code=${organization}`
    );
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching student data:", error);
  }
};

const fetchSchoolUsersData = async (backendUrl, uuid) => {
  try {
    let data = await fetch(
      `${backendUrl}/school/users?uuid=${uuid}`
    );
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching student data:", error);
  }
};

const deleteStudent = async (backendUrl, username) => {
  try {
    let data = await fetch(`${backendUrl}/student/delete`, {
      method: "PATCH",
      body: JSON.stringify({username: username}),
      headers: {
        "Content-Type": "application/json",
      },
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error updating student data:", error);
  }
};

const fetchUserSubscriberData = async (backendUrl, username) => {
  try {
    let data = await fetch(
      `${backendUrl}/subscriber/user/subscriber?username=${username}`
    );
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching student data:", error);
  }
};
const ezStudentRegistration = async (backendUrl, formData) => {
  try {
    let data = await fetch(`${backendUrl}/registration/ezstudent`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error updating student data:", error);
  }
};

const fetchUserProfileData = async (backendUrl, username, subscriberCode) => {
  try {
    let data = await fetch(`${backendUrl}/user/profile?username=${username}&subcode=${subscriberCode}`);
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching student data:", error);
  }
};

const changePasswordByUser = async (backendUrl, formData) => {
  try {
    let data = await fetch(`${backendUrl}/user/change_password`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error updating password:", error);
  }
};
const createSubscriber = async (backendUrl, formData) =>{
  try {
    let data = await fetch(`${backendUrl}/subscriber/create`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error creating school:", error);
  }
}

const fetchCountWithRole = async (backendUrl, subscriberCode, username) => {
  try {
    let data = await fetch(`${backendUrl}/subscriber/count?subcode=${subscriberCode}&username=${username}`);
    data = await data.json();
    return data.data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching Count data:", error);
  }
};

const fetchOrganizationDetails = async (backendUrl, subscriberCode) => {
  try {
    let data = await fetch(`${backendUrl}/subscriber/profile?subcode=${subscriberCode}`);
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching Count data:", error);
  }
};

const updateUserRole = async (backendUrl,subscriberCode, rows, roles) =>{
  try {
    let data = await fetch(`${backendUrl}/user/role`, {
      method: "PATCH",
      body: JSON.stringify({rows, roles, subscriberCode}),
      headers: {
        "Content-Type": "application/json",
      },
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error updating roles:", error);
  }
}

const fetchRoleCodeDetail = async (backendUrl, roleCode) => {
  try {
    let data = await fetch(`${backendUrl}/user/rolename?rolecode=${roleCode}`);
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching role data:", error);
  }
};

const updatePublicProfile = async (backendUrl, formData) =>{
  try {
    let data = await fetch(`${backendUrl}/user/public_profile`, {
      method: "PATCH",
      body: formData
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error updating public profile:", error);
  }
}

const fetchPublicProfile = async (backendUrl, username) => {
  try {
    let data = await fetch(`${backendUrl}/user/public_profile?username=${username}`);
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching role data:", error);
  }
};

const fetchSubscriberTeams = async (backendUrl, subscriberCode) => {
  try {
    let data = await fetch(`${backendUrl}/teams?subcode=${subscriberCode}`);
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching role data:", error);
  }
};

const createTeam = async (backendUrl, formData) =>{
  try {
    let data = await fetch(`${backendUrl}/teams`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error creating school:", error);
  }
}

const fetchUsersBySubscriber = async (backendUrl, subscriberCode, username, searchKey) => {
  try {
    let data = await fetch(`${backendUrl}/user/get-usernames?subcode=${subscriberCode}&searchUsernameInput=${searchKey}&username=${username}`);
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching role data:", error);
  }
};
const fetchPersonalProfile = async (backendUrl, username) => {
  try {
    let data = await fetch(`${backendUrl}/user/${username}`);
    data = await data.json();
    return data;
  } catch (error) {
    // Handle any errors here
    console.error("Error fetching role data:", error);
  }
};
const updateUser = async (backendUrl, formData) =>{
  try {
    let data = await fetch(`${backendUrl}/user/`, {
      method: "PUT",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    });
    data = await data.json();
    return data
  } catch (error) {
    console.error("Error creating school:", error);
  }
}
export { fetchStudentData, fetchInstructorsData, updateUserProfile, fetchUsersData, deleteStudent, fetchSchoolsData, fetchSchoolUsersData, fetchUserSubscriberData, ezStudentRegistration, fetchUserProfileData, changePasswordByUser, createSubscriber, fetchCountWithRole, fetchOrganizationDetails, updateUserRole, fetchRoleCodeDetail, updatePublicProfile, fetchPublicProfile, fetchSubscriberTeams, createTeam, fetchUsersBySubscriber, fetchPersonalProfile, updateUser };